// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"ff48e093","319":"dea8e6c7","508":"fb3a724e"}[chunkId] + ".chunk.css";
};